module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/shutterstock_2226128901.0ba21c3d.png";